import React from "react";
import {
  //  useTranslation,
  withTranslation,
} from "react-i18next";
import { DefaultImg } from "../../components/images";
import { Col, Row } from "antd";
import { PROPERTY_TYPE, WIDTH_MOBILE } from "../../common/constant";
import { checkSpecialMattress } from "../../shared/helpers";

const ProductOrder = (props: any) => {
  const { product } = props;
  // const { t } = useTranslation();
  const { innerWidth } = window;

  const getImage = () => {
    let image = product.img ? product.img : DefaultImg;

    if (product && product.product_property) {
      if (product.product_property[PROPERTY_TYPE.image]) {
        image = product.product_property[PROPERTY_TYPE.image].img;
        if (!image) {
          image = product.product_property[PROPERTY_TYPE.image].image;
        }
        if (!image) {
          image = DefaultImg;
        }
      }
    }

    return image;
  };

  const renderMoreProperty = () => {
    let displayValue = "";

    if (product && product.product_property) {
      if (product.product_property[PROPERTY_TYPE.image]) {
        displayValue = product.product_property[PROPERTY_TYPE.image].label;
      }
      if (product.product_property[PROPERTY_TYPE.cover]) {
        displayValue = product.product_property[PROPERTY_TYPE.cover].label;
      }
      if (product.product_property[PROPERTY_TYPE.foam]) {
        displayValue = product.product_property[PROPERTY_TYPE.foam].label;
      }
    }

    return <span className="main-content">{displayValue}</span>;
  };

  return (
    <div className="product-order-item-wrapper">
      <Row align="middle" className="product-order-item-wrap">
        <Col
          // span={11}
          xs={12}
          sm={10}>
          <Row justify="center">
            <div className="product-order-item-image">
              <img src={getImage()} alt="" />
            </div>
          </Row>
        </Col>
        {innerWidth > WIDTH_MOBILE ? (
          <>
            <Col span={6}>
              <Row>
                <span className="main-content item-product-name">
                  {product.name}
                </span>
              </Row>
              <Row>{renderMoreProperty()}</Row>
              <Row>
                <span className="main-content">{product.feature_name}</span>
              </Row>
              <Row>
                <span className="main-content item-quantity">
                  Số lượng:{" "}
                  <span className="item-price">{product.quantity}</span>
                </span>
              </Row>
            </Col>
            <Col span={6}>
              <Row justify="end">
                <span className="main-content ">Giá bán/SP:</span>
              </Row>
              <Row justify="end">
                <span className="main-content item-price">
                  {product.discounted_price} VND
                </span>
              </Row>
              {!checkSpecialMattress(
                product.price,
                product.discounted_price
              ) && (
                <Row justify="end">
                  <span className="main-content item-unit-price">
                    {product.price} VND
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span className="main-content item-discount-percent">
                    {product.discount_percent || "0%"}
                  </span>
                </Row>
              )}
            </Col>
          </>
        ) : (
          <Col span={12}>
            <Row>
              <span className="main-content item-product-name">
                {product.name}
              </span>
            </Row>
            <Row>
              <span className="main-content item-product-feature">
                {product.feature_name}
              </span>
            </Row>
            <Row>
              <span className="main-content item-quantity">
                Số lượng:{" "}
                <span className="item-price  item-quantity-value">
                  {product.quantity}
                </span>
              </span>
            </Row>
            <Row>
              <span className="main-content label-price">Giá bán/SP:</span>
            </Row>
            <Row>
              <span className="main-content item-price">
                {product.discounted_price}
              </span>
            </Row>
            {!checkSpecialMattress(product.price, product.discounted_price) && (
              <Row>
                <span className="main-content item-unit-price">
                  {product.price}
                </span>
                &nbsp;&nbsp;
                <span className="main-content item-discount-percent">
                  {product.discount_percent || "0%"}
                </span>
              </Row>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
};

export default withTranslation()(ProductOrder);
